import { render, staticRenderFns } from "./_header.vue?vue&type=template&id=bdcd0016&"
import script from "./_header.vue?vue&type=script&lang=js&"
export * from "./_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports